import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { Dtos } from '#models';

@Injectable({
  providedIn: 'root',
})
export class SystemAdminService {
  private http = inject(HttpClient);

  public getAll(): Observable<Dtos.SystemAdmin[]> {
    return this.http.get<Dtos.SystemAdmin[]>(`${environment.apiUrl}/system-admin`);
  }

  public createSystemAdmin(sysAdmin: Dtos.SystemAdmin): Observable<Dtos.SystemAdmin> {
    return this.http.post<Dtos.SystemAdmin>(`${environment.apiUrl}/system-admin`, sysAdmin);
  }

  public updateSystemAdmin(sysAdmin: Dtos.SystemAdmin): Observable<Dtos.SystemAdmin> {
    return this.http.put<Dtos.SystemAdmin>(`${environment.apiUrl}/system-admin`, sysAdmin);
  }
}
